export default function NotFound() {
    return (
      <div className="text-white p-10">
        <h1 className="text-3xl font-bold">NotFound Page</h1>
      </div>
    )
  }
  